/**
 * @generated SignedSource<<b9ec0ae283e2810c643d42e017003604>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ScreenColumn_FeedbackFragment$data = {
  readonly screen: string | null | undefined;
  readonly " $fragmentType": "ScreenColumn_FeedbackFragment";
};
export type ScreenColumn_FeedbackFragment$key = {
  readonly " $data"?: ScreenColumn_FeedbackFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ScreenColumn_FeedbackFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ScreenColumn_FeedbackFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "screen",
      "storageKey": null
    }
  ],
  "type": "FeedbackV2",
  "abstractKey": null
};

(node as any).hash = "f419908d78a636c6c9d7f9c94023e914";

export default node;
